import React, { createContext, useContext, useState, useMemo } from 'react';
import { CONFIGURATIONS } from '../config';

const ConfigContext = createContext();

export const ConfigProvider = ({ initialYear = '2025', initialTaxYear = '2025', initialIsScottish = false, children }) => {
  // Support both initialYear (new) and initialTaxYear (legacy) props
  const yearToUse = initialYear || initialTaxYear;
  const [taxYear, setTaxYear] = useState(yearToUse);
  const [isScottish, setIsScottish] = useState(initialIsScottish);

  // Compute the effective configuration key supporting both 2024 and 2025
  let configKey = taxYear;
  if (isScottish && (taxYear === '2024' || taxYear === '2025')) {
    configKey = `${taxYear}_scottish`;
  }
  const config = CONFIGURATIONS[configKey] || CONFIGURATIONS[yearToUse] || CONFIGURATIONS['2025'];

  // Memoize the context value to avoid unnecessary re-renders.
  const contextValue = useMemo(() => ({
    config,
    taxYear,
    isScottish,
    setTaxYear,
    setIsScottish,
  }), [config, taxYear, isScottish]);

  return (
    <ConfigContext.Provider value={contextValue}>
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => useContext(ConfigContext);